export enum LeadEmailFormTypeEnum {
  /**
   * Default email form
   */
  default = 'default',

  /**
   * Live viewing email form
   */
  liveViewing = 'liveViewing',

  /**
   * Email form inside live viewing popup
   */
  liveViewingPopup = 'liveViewingPopup',
}
